import React, { useState } from 'react';

import { styled, Box } from '@mui/material';

// Components
import { AdminPage, ControlBar, ControlBarButton, ControlBarHeader } from 'components/ui/layout';
import UserList from 'pages/admin/user/UserList';
import FullScreenModal from 'components/popups/FullScreenModal';
import UserFormDetail from 'pages/admin/user/UserFormDetail';
import UserFormPassword from 'pages/admin/user/UserFormPassword';

export default function Users() {
    const [refresh, setRefresh] = useState(0);

    const [createUserModal, setCreateUserModal] = useState(false);

    const [editUserModal, setEditUserModal] = useState({
        open: false,
        userId: null,
    });
    const [editPasswordModal, setEditPasswordModal] = useState({
        open: false,
        userId: null,
    });

    const openCreateUser = () => setCreateUserModal(true);
    const closeCreateUser = () => setCreateUserModal(false);

    const onCreateUser = () => {
        setCreateUserModal(false);
        setRefresh((r) => r + 1);
    };

    const openEditUser = (id) => setEditUserModal({ open: true, userId: id });
    const closeEditUser = () => setEditUserModal({ open: false, userId: null });

    const onEditUser = () => {
        closeEditUser();
        setRefresh((r) => r + 1);
    };

    const openEditPassword = (id) => setEditPasswordModal({ open: true, userId: id });
    const closeEditPassword = () => setEditPasswordModal({ open: false, userId: null });

    const onEditPassword = () => {
        closeEditPassword();
    };

    return (
        <AdminPage>
            <Container>
                <ControlBar>
                    <ControlBarHeader>Users</ControlBarHeader>
                    <ControlBarButton onClick={openCreateUser}>New User</ControlBarButton>
                </ControlBar>

                <Box display={'flex'} flex={1} width={'100%'}>
                    <UserList
                        dependency={refresh}
                        onEditUser={openEditUser}
                        onEditPassword={openEditPassword}
                    />
                </Box>

                <FullScreenModal
                    open={createUserModal}
                    onClose={closeCreateUser}
                    title="Create User"
                >
                    <UserFormDetail onUpdate={onCreateUser} onCancel={closeCreateUser} />
                </FullScreenModal>

                <FullScreenModal
                    open={editUserModal.open}
                    onClose={closeEditUser}
                    title="Edit User"
                >
                    <UserFormDetail
                        userId={editUserModal.userId}
                        onUpdate={onEditUser}
                        onCancel={closeEditUser}
                    />
                </FullScreenModal>

                <FullScreenModal
                    open={editPasswordModal.open}
                    onClose={closeEditPassword}
                    title="Edit Password"
                >
                    <UserFormPassword
                        userId={editPasswordModal.userId}
                        onUpdate={onEditPassword}
                        onCancel={closeEditPassword}
                    />
                </FullScreenModal>
            </Container>
        </AdminPage>
    );
}

const Container = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
}));
